<template>
  <section class="main-page">
    <section class="page-section mb-3">
      <div class="container-fluid">
        <div class="card">
          <div class="text-2xl text-primary font-bold">
            {{ $t("your_dashboard") }}
          </div>
        </div>
      </div>
    </section>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="col-12 md:col-6 sm:col-12 comp-grid">
            <div class="sticky-item">
              <div class="card nice-shadow-18">
                <small class="text-gray-500">
                  {{ $utils.humanDate($utils.dateTimeNow()) }}
                </small>
                <div class="text-2xl font-bold mt-1">
                  {{ $t("welcome_to_caps") }}
                </div>
                <div class="my-3">
                  <p>
                    {{ $t("click_button_to_load_applcaition_form") }}
                  </p>
                </div>
                <div>
                  <router-link to="/applicants/edit">
                    <Button
                      :class="
                        user.application_status != 'Completed'
                          ? ''
                          : 'p-button-success'
                      "
                      :label="
                        user.application_status != 'Completed'
                          ? $t('open_application_form')
                          : $t('application_summary')
                      "
                    />
                  </router-link>
                </div>
              </div>
              <div v-if="currentAppConfig" class="">
                <div class="card nice-shadow-18">
                  <div class="text-lg font-bold text-primary">
                    {{ $t("important_notice") }}
                  </div>
                  <div class="my-3">
                    <div class="mb-2">
                      <Avatar
                        style="background-color: #5b51f8; color: #ffffff"
                        icon="pi pi-calendar"
                        shape="circle"
                        size="small"
                      />
                      <span class="ml-2"
                        >{{ $t("academic_year") }}:
                        {{ currentAppConfig.academic_year }}</span
                      >
                    </div>
                    <div class="mb-2">
                      <Avatar
                        style="background-color: #5b51f8; color: #ffffff"
                        icon="pi pi-money-bill"
                        shape="circle"
                        size="small"
                      />
                      <span class="ml-2">{{ $t("form_fees") }}: </span>
                      <Chip
                        :label="'GHS ' + currentAppConfig.application_form_fee"
                      />
                    </div>
                    <div class="mb-2">
                      <Avatar
                        style="background-color: #5b51f8; color: #ffffff"
                        icon="pi pi-clock"
                        shape="circle"
                        size="small"
                      />
                      <span class="ml-2">
                        {{ $t("deadline_for_submission") }}: <span class=" text-pink-500">
                        {{
                          $utils.humanDate(
                            currentAppConfig.application_deadline, "medium"
                          )
                        }}</span> 
                      </span>
                    </div>
                  </div>
                  <div></div>
                </div>
              </div>
              <div class="card nice-shadow-18">
                <!-- <div class="text-2xl font-bold mt-1">
                  {{ $t("minimum_requirements_for_admission_to_tertiary") }}
                </div> -->
                <div class="my-3">
                  <p>
                    {{ $t("Further_to_earlier_notices_issued_phrase") }}
                  </p>
                </div>
                <div>
                  <router-link to="/minimum_entry_requirements">
                    <Button :label="$t('minimum_entry_requirements')" />
                  </router-link>
                </div>
              </div>
            </div>
            <!-- <div class="card"></div>
            <div class="card"></div>
            <div class="card"></div>
            <div class="card"></div> -->
          </div>
          <div class="col-12 md:col-6 sm:col-12 comp-grid">
            <div class="card nice-shadow-18">
              <div class="text-lg font-bold text-primary">
                {{ $t("application_status_overview") }}
                <Divider />
              </div>
              <div class="my-3">
                <div class="grid">
                  <div class="col-12">
                    <Timeline
                      :value="[
                        {
                          title: $t('application_form_created'),
                          subtitle: $t('completed'),
                          icon: 'pi pi-check',
                          color: successColor,
                          button: false,
                        },
                        {
                          title: $t('bio_information'),
                          subtitle: user.firstname
                            ? $t('completed')
                            : $t('pending'),
                          icon: 'pi pi-user-edit',
                          color: user.firstname ? successColor : pendingColor,
                          button: true,
                          index: 0,
                        },
                        {
                          title: $t('family_information'),
                          subtitle: user.fathers_name
                            ? $t('completed')
                            : $t('pending'),
                          icon: 'pi pi-users',
                          color: user.firstname ? successColor : pendingColor,
                          button: true,
                          index: 1,
                        },
                        {
                          title: $t('academic_history'),
                          subtitle: user.attended_shs
                            ? $t('completed')
                            : $t('pending'),
                          icon: 'pi pi-book',
                          color: user.attended_shs
                            ? successColor
                            : pendingColor,
                          button: true,
                          index: 2,
                        },
                        {
                          title: $t('programme_selections'),
                          subtitle: user.first_institution_first_programme_id
                            ? $t('completed')
                            : $t('pending'),
                          icon: 'pi pi-th-large',
                          color: user.first_institution_first_programme_id
                            ? successColor
                            : pendingColor,
                          button: true,
                          index: 3,
                        },
                        {
                          title: $t('funding_or_scholarship'),
                          subtitle: user.is_fee_paying
                            ? $t('completed')
                            : $t('pending'),
                          icon: 'pi pi-star',
                          color: user.is_fee_paying
                            ? successColor
                            : pendingColor,
                          button: true,
                          index: 4,
                        },
                        {
                          title: $t('payment'),
                          subtitle:
                            user.payment_status == paid
                              ? $t('completed')
                              : $t('pending'),
                          icon: 'pi pi-wallet',
                          color:
                            user.payment_status == paid
                              ? successColor
                              : pendingColor,
                          button: true,
                          index: 5,
                        },
                        {
                          title: $t('application_submitted'),
                          subtitle:
                            user.application_status == completed
                              ? $t('completed')
                              : $t('pending'),
                          icon: 'pi pi-send',
                          color:
                            user.application_status == completed
                              ? successColor
                              : pendingColor,
                          button: true,
                          index: 6,
                        },
                      ]"
                      align="alternate"
                      class="customized-timeline"
                    >
                      <template #marker="slotProps">
                        <span
                          style="width: 2.6rem; height: 2.6rem"
                          class="custom-marker shadow-2"
                          :style="{ backgroundColor: slotProps.item.color }"
                        >
                          <i :class="slotProps.item.icon"></i>
                        </span>
                      </template>
                      <template #content="slotProps">
                        <div class="card nice-shadow-6">
                          <div class="grid">
                            <div class="col-12">
                              <div class="text-lg font-bold">
                                {{ slotProps.item.title }}
                              </div>
                              <div
                                class="text-sm"
                                :style="{ color: slotProps.item.color }"
                              >
                                {{ slotProps.item.subtitle }}
                              </div>
                              <div class="mt-2">
                                <Button
                                  :label="$t('view')"
                                  class="p-button-outlined p-button-sm"
                                  :class="
                                    slotProps.item.color == pendingColor
                                      ? 'p-button-warning'
                                      : 'p-button-success'
                                  "
                                  @click="editApplication(slotProps.item.index)"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </Timeline>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>
<script>
import { PageMixin } from "../../mixins/page.js";
import Timeline from "primevue/timeline";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "homePage",
  components: { Timeline },
  mixins: [PageMixin],
  props: {
    pageName: {
      type: String,
      default: "home",
    },
    routeName: {
      type: String,
      default: "homePage",
    },
  },
  meta() {
    return {
      title: this.pageTitle,
    };
  },
  data: function () {
    return {
      ready: false,
      successColor: "#087408",
      pendingColor: "#9f6810",
      paid: "Paid",
      completed: "Completed",
    };
  },
  computed: {
    ...mapGetters("app_config", ["currentAppConfig"]),
    ...mapGetters("auth", ["user"]),
    pageTitle: {
      get: function () {
        return this.$t("welcome_to_caps");
      },
    },
  },
  methods: {
    editApplication(index) {
      let pageIndex = index;
      this.$router.push({
        name: "applicantsedit",
        params: { pageIndex },
      });
    },
  },
  watch: {},
  async mounted() {
    this.ready = true;
    await this.$store.dispatch("auth/getUserData");
    await this.$store.dispatch("app_config/fetchAppConfig");
  },
  async created() {
    // await this.$store.dispatch("auth/getUserData");
  },
};
</script>
<style lang="scss" scoped>
.custom-marker {
  display: flex;
  width: 2rem;
  height: 2rem;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  border-radius: 50%;
  z-index: 1;
}

::v-deep(.p-timeline-event-content) ::v-deep(.p-timeline-event-opposite) {
  line-height: 1;
}

@media screen and (max-width: 960px) {
  ::v-deep(.customized-timeline) {
    .p-timeline-event:nth-child(even) {
      flex-direction: row !important;

      .p-timeline-event-content {
        text-align: left !important;
      }
    }

    .p-timeline-event-opposite {
      flex: 0;
    }

    .p-card {
      margin-top: 1rem;
    }
  }
}
</style>
